import api from 'api/apiInstance';

import type { SuitabilityLetterResponse } from '../types';

export function clientCaseSuitabilityLettersLastApi(path: string) {
  return {
    path,
    GET: () =>
      api.get<SuitabilityLetterResponse>(path, {
        // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
        // 403 (cross-tenant) must not bounce the adviser off the case page;
        // 404 means the COBS 9A flag is off — the panel renders nothing.
        skipRedirect: true,
      }),
  };
}
